<div class="cliniweb-directory-link-container">
    <img *ngFor="let item of doctors; let i = index" [src]="item"/>
    <div class="others">{{numberOfDoctors}}</div>
    <a class="link" routerLink="/doctores">{{'shared.medicalOrderLanding.seeDirectory' | translate:locale.language}}</a>
</div>